import { render, staticRenderFns } from "./SelectTypeSelector.vue?vue&type=template&id=2e3c079c&scoped=true&"
import script from "./SelectTypeSelector.vue?vue&type=script&lang=ts&"
export * from "./SelectTypeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SelectTypeSelector.vue?vue&type=style&index=0&id=2e3c079c&prod&lang=scss&scoped=true&deep=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3c079c",
  null
  
)

export default component.exports